import { CAROUSEL_TYPE } from 'consts/enum';

const { STACKED_SEPARATED_DOT, HORIZONTAL } = CAROUSEL_TYPE;

function getTranslateX(element) {
	return parseInt(element.style.transform?.split?.('translate3d(')?.[1]?.split?.('px,')?.[0] || 0);
}

function setTranslate(xPos, el) {
	if (xPos > 0 || !el.style) {
		return;
	}

	el.style.transform = `translate3d(${xPos}px, 0px, 0px)`;
}

export function initDragListeners() {
	const ref = this;
	const { id, type } = this.data;
	const container = this.html.querySelector(`#engtCarousel-${id}`);
	const totalNoOfCards = parseInt(container.getAttribute('data-slide-length'));

	this.isDragActive = false;
	this.currentX = 0;
	this.initialX;
	this.xOffset = 0;
	this.whenStartX = 0;
	this.maxCarouselLength = 0;

	container.addEventListener('touchstart', dragStart, false);
	container.addEventListener('touchend', dragEnd, false);
	container.addEventListener('touchcancel', dragEnd, false);
	container.addEventListener('touchmove', dragInProgress, false);

	container.addEventListener('mousedown', dragStart, false);
	container.addEventListener('mouseup', dragEnd, false);
	container.addEventListener('mouseleave', dragEnd, false);
	container.addEventListener('mousemove', dragInProgress, false);
	container.addEventListener('mouseover', onMouseEnter, false);

	function onMouseEnter() {
		this.whenStartX = this.xOffset = this.currentX = getTranslateX(container);
	}

	function dragStart(e) {
		try {
			if (e.type === 'touchstart') {
				this.initialX = e.touches[0].clientX - this.xOffset;
			} else {
				this.initialX = e.clientX - this.xOffset;
			}

			if (!ref.maxCarouselLength) {
				const carouselWrapper = ref.html.querySelector(`#engtCarousel-${id}`);
				const carouselCards = carouselWrapper.children;

				for (let i = 0; i < carouselCards.length; i++) {
					ref.maxCarouselLength += carouselCards[i].scrollWidth;
				}
			}

			this.whenStartX = this.currentX;
			this.isDragActive = true;
		} catch (e) {
			console.error('Got error handling carousel drag start event', e);
		}
	}

	function dragEnd(e) {
		if (this.currentX > 0) {
			this.isDragActive = false;
			this.whenStartX = this.xOffset = this.currentX = 0;
			return;
		}
		if (this.whenStartX === this.currentX) {
			this.isDragActive = false;
			return;
		}

		try {
			this.initialX = this.currentX;
			this.isDragActive = false;

			const activeElement = ref.html.querySelector(`#engtCarousel-${id}>div[data-active='true']`);
			const widthOfElement = activeElement.scrollWidth;
			const slideLength = totalNoOfCards * widthOfElement + totalNoOfCards * 8 - 8;
			const postCurrentX = Math.abs(this.currentX);

			if (type === HORIZONTAL || type === STACKED_SEPARATED_DOT) {
				if (postCurrentX - Math.abs(this.whenStartX) > 30) {
					ref.onCarouselNext(e, ref.html.querySelector(`#engtCarousel-${id}`));
				} else if (Math.abs(postCurrentX - Math.abs(this.whenStartX)) > 30) {
					ref.onCarouselPrevious(e, ref.html.querySelector(`#engtCarousel-${id}`));
				}
				this.whenStartX = this.xOffset = this.currentX = getTranslateX(container);
			} else if (postCurrentX < widthOfElement / 4) {
				ref.onCarouselDotClick(ref.carouselId, 0);
				this.whenStartX = this.xOffset = 0;
			} else if (postCurrentX > widthOfElement && postCurrentX < slideLength) {
				const goToSlide = Math.round(postCurrentX / widthOfElement);

				if (goToSlide === totalNoOfCards) {
					if (ref.isCircular) {
						ref.onCarouselDotClick(ref.carouselId, totalNoOfCards);
						this.whenStartX = this.xOffset = 0;
					}
				} else {
					ref.onCarouselDotClick(ref.carouselId, goToSlide);
					this.whenStartX = this.xOffset = getTranslateX(container);
				}
			} else if (postCurrentX > slideLength) {
				if (ref.isCircular) {
					ref.onCarouselDotClick(ref.carouselId, totalNoOfCards);
					this.whenStartX = this.xOffset = 0;
				}
			} else {
				ref.onCarouselDotClick(ref.carouselId, 1);
				this.whenStartX = this.xOffset = getTranslateX(container);
			}
		} catch (e) {
			console.error('Got error handling carousel drag end event', e);
		}
	}

	function dragInProgress(e) {
		e.preventDefault();
		e.stopPropagation();
		try {
			if (this.isDragActive) {
				if (e.type === 'touchmove') {
					this.currentX = e.touches[0].clientX - this.initialX;
				} else {
					this.currentX = e.clientX - this.initialX;
				}

				this.xOffset = this.currentX;

				if (type !== HORIZONTAL && type !== STACKED_SEPARATED_DOT) {
					if (!ref.isCircular) {
						if (Math.abs(this.currentX) <= ref.maxCarouselLength - 190) {
							setTranslate(this.currentX, container);
						}
					} else if (Math.abs(this.currentX) <= ref.maxCarouselLength) {
						setTranslate(this.currentX, container);
					}
				}
			}
		} catch (e) {
			console.error('Got error handling carousel dragging event', e);
		}
	}
}
